import { css } from "@emotion/react"
import { Checkbox } from "@planningcenter/doxy-web"
import { useMemo } from "react"
import { formattedCents } from "source/giving/utils/money"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { Designation, StripePaymentMethod } from "../types"
import { coveredFeeCents } from "../utils/coverTheFee"

interface CoverTheFeeProps {
  designations: Designation[]
  feeCovered: boolean
  stripePaymentMethod: StripePaymentMethod
}

export function CoverTheFee({
  designations,
  feeCovered,
  stripePaymentMethod,
}: CoverTheFeeProps) {
  const { config, dispatch } = useDonationFormContext()
  const feeDollars = useMemo(
    () =>
      formattedCents(
        coveredFeeCents(config, designations, stripePaymentMethod.type),
      ),
    [config, designations, stripePaymentMethod.type],
  )
  const showBankComparison =
    stripePaymentMethod.type === "card" ||
    stripePaymentMethod.type === "apple_pay"
  const label: unknown = (
    <span className="fw-600">
      Add {feeDollars} to cover the processing&nbsp;fee
    </span>
  )

  return (
    <div
      css={css`
        padding-left: 1.1rem; // align with payment methods above
      `}
    >
      <Checkbox
        id="cover-the-fee-checkbox"
        checked={feeCovered}
        label={label as string}
        onChange={(event) => {
          dispatch({
            type: "SET_FEE_COVERED",
            feeCovered: event.target.checked,
          })
        }}
      />
      {showBankComparison && <BankFeeComparison {...{ designations }} />}
    </div>
  )
}

function BankFeeComparison({ designations }: { designations: Designation[] }) {
  const { config } = useDonationFormContext()
  const bankFeeDollars = useMemo(
    () => formattedCents(coveredFeeCents(config, designations, "bank")),
    [config, designations],
  )
  return (
    <small
      className="c-tint2 fs-5 d-b mt-4p pl-3" // match `.checkbox-label` padding
    >
      Fees are only {bankFeeDollars} when you give through your&nbsp;bank
    </small>
  )
}
